import React from "react";
import { Save, Loader2 } from "lucide-react";

interface FloatingSaveButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  title?: string;
}

// Botão fixo no canto da tela para salvar sem navegar para outra página
export function FloatingSaveButton({ onClick, loading = false, disabled = false, title = "Salvar" }: FloatingSaveButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      title={title}
      aria-label={title}
      className="fixed bottom-6 right-6 z-[1300] inline-flex h-14 w-14 items-center justify-center rounded-full bg-primary-600 text-white shadow-lg transition-colors hover:bg-primary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
    >
      {loading ? <Loader2 className="h-6 w-6 animate-spin" /> : <Save className="h-6 w-6" />}
    </button>
  );
}
